import type { Procedure } from '../../../../app-core/lib/procedure/Procedure'
import { common_CLEAR_DATA } from '../actions/common'
import type { TReduxAction } from '../actions'
import type { Form_IForm } from '../../../zap/Form/Form.types'
import type {
    Type_IActionType,
    Type_ICalendarEvent,
    Type_ILocation,
    Type_ILocationFocusList,
    Type_IReport,
    Type_IUnit,
    Type_IUnitList,
    Type_Workflow,
} from '../../../zap/Type/Type.hive'
import {
    RECEIVE_ACTION_TYPES,
    RECEIVE_ACTIVITIES,
    RECEIVE_CALENDAR_EVENTS,
    RECEIVE_CAMPAIGNS,
    RECEIVE_FOCUS_LISTS,
    RECEIVE_FORMS,
    RECEIVE_LOCATIONS,
    RECEIVE_REPORTS,
    RECEIVE_UNIT_LISTS,
    RECEIVE_UNIT_TYPES,
    RECEIVE_UNITS,
} from '../actions/entities'
import type { AppUnitType } from '../../../../shared/domain/units/types.no-deps'

export type TEntitiesState = {
    activities: Type_Workflow[]
    actionTypes: Type_IActionType[] // activity-tasks in the db
    calendarEvents: Type_ICalendarEvent[]
    campaigns: Procedure[]
    focusLists: Type_ILocationFocusList[]
    forms: Form_IForm[]
    locations: Type_ILocation[]
    reports: Type_IReport[]
    units: Type_IUnit[]
    unitTypes: AppUnitType[]
    unitLists: Type_IUnitList[]
}

const initialState = {
    activities: [] as Type_Workflow[],
    actionTypes: [] as Type_IActionType[],
    calendarEvents: [] as Type_ICalendarEvent[],
    campaigns: [] as Procedure[],
    focusLists: [] as Type_ILocationFocusList[],
    forms: [] as Form_IForm[],
    locations: [] as Type_ILocation[],
    reports: [] as Type_IReport[],
    units: [] as Type_IUnit[],
    unitTypes: [] as AppUnitType[],
    unitLists: [] as Type_IUnitList[],
}

export function entitiesReducer(state: TEntitiesState = initialState, action: TReduxAction): TEntitiesState {
    switch (action.type) {
        case RECEIVE_ACTIVITIES:
            return {
                ...state,
                activities: action.data,
            }
        case RECEIVE_ACTION_TYPES:
            return {
                ...state,
                actionTypes: action.data,
            }
        case RECEIVE_CALENDAR_EVENTS:
            return {
                ...state,
                calendarEvents: action.data,
            }
        case RECEIVE_CAMPAIGNS:
            return {
                ...state,
                campaigns: action.data,
            }
        case RECEIVE_FOCUS_LISTS:
            return {
                ...state,
                focusLists: action.data,
            }
        case RECEIVE_FORMS:
            return {
                ...state,
                forms: action.data,
            }
        case RECEIVE_LOCATIONS:
            return {
                ...state,
                locations: action.data,
            }
        case RECEIVE_REPORTS:
            return {
                ...state,
                reports: action.data,
            }
        case RECEIVE_UNITS:
            return {
                ...state,
                units: action.data,
            }
        case RECEIVE_UNIT_TYPES:
            return {
                ...state,
                unitTypes: action.data,
            }
        case RECEIVE_UNIT_LISTS:
            return {
                ...state,
                unitLists: action.data,
            }
        case common_CLEAR_DATA:
            return initialState
        default:
            return state
    }
}

export function getEntityById<K extends keyof TEntitiesState>(
    state: TEntitiesState,
    entity: K,
    id: number
): TEntitiesState[K][0] {
    const test: any = state[entity]
    return test.find((e: any) => e.id === id)
}

export function getEntityArray<K extends keyof TEntitiesState>(state: TEntitiesState, entity: K): TEntitiesState[K] {
    return state[entity]
}

// export function getEntityMap/Lookup (state: TEntitiesState, entity: TEntityName): // {
//     return // ;
// }
